"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryCharacteristicStateSummaryExternalSchema = void 0;
const zod_1 = require("zod");
const BoundaryAssertionStrength_1 = require("../BoundaryAssertionStrength");
const BoundaryCharacteristic_1 = require("../BoundaryCharacteristic");
const DesignModels_1 = require("../DesignModels");
const CharacteristicValue_1 = require("./CharacteristicValue");
const ISerializedProvenanceNode_1 = require("./ISerializedProvenanceNode");
exports.BoundaryCharacteristicStateSummaryExternalSchema = zod_1.default.object({
    assertionStrength: zod_1.default.lazy(() => BoundaryAssertionStrength_1.BoundaryAssertionStrengthSchema),
    characteristic: zod_1.default.lazy(() => BoundaryCharacteristic_1.BoundaryCharacteristicSchema),
    derivedFromBoundaries: zod_1.default.lazy(() => DesignModels_1.BoundaryGlobalIdRefSchema.array()),
    derivedFromSimulations: zod_1.default
        .lazy(() => DesignModels_1.SimulationDefinitionSchema)
        .array()
        .optional(),
    derivedFromSpecifications: zod_1.default.string().array().optional(),
    value: zod_1.default.lazy(() => CharacteristicValue_1.CharacteristicValueSchema),
    isPartialResolution: zod_1.default.boolean().optional(),
    fromSource: zod_1.default.boolean().optional(),
    provenance: zod_1.default.lazy(() => ISerializedProvenanceNode_1.ISerializedCharacteristicProvenanceSchema).optional(),
});
//# sourceMappingURL=BoundaryCharacteristicStateSummaryExternal.js.map